export const defaultRetryCounter = 5;
